
/**
 * 商户接口服务（纯接口请求）
 */
export const businessService = {
  /**
   * 获取筛选后的商户列表
   * @param {Object} params 筛选参数（category必传）
   * @returns {Promise<Response>} 后端原始响应
   */
  getBusinesses: (params) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) query.append(key, value);
    });
    return fetch(`/qhkj-agri-map-api/base/recommended/content/getH5List?${query.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  },
  /**
   * 获取详情
   * @param {Object} params 筛选参数（id必传）
   * @returns {Promise<Response>} 后端原始响应
   */
  getDetail: (params) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) query.append(key, value);
    });

    // const categoryId = query.get("category") || "homestay";
    // const data = businesses[categoryId].find(item => item.id === params.id);
    // return {...data, categoryId: categoryId }
    return fetch(`/qhkj-agri-map-api/base/recommended/content/getDetail?${query.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
};